export const environment = {
  production: true,
  firebase:   {
    apiKey: "AIzaSyAyPE91RrimRt7TMl99yYk1lDRZr1mSJ3Q",
    authDomain: "osmpro-a9699.firebaseapp.com",
    projectId: "osmpro-a9699",
    storageBucket: "osmpro-a9699.appspot.com",
    messagingSenderId: "969828274998",
    appId: "1:969828274998:web:100de3fcd734f91cdc9997",
    measurementId: "G-1PJHBD0DFP"
  }
};
